import { getImageUrl } from "@erp/shared/api/generated/wrappers/s3";
import { extractOriginalName } from "./file-name";
/**
 * 파일을 다운로드
 * @param fileName 파일명
 */
export const downloadS3File = async (fileName) => {
    try {
        const signedUrl = await getImageUrl(fileName);
        const response = await fetch(signedUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const blob = await response.blob();
        const showFileName = extractOriginalName(fileName);
        if (!showFileName) {
            throw new Error("파일명을 추출할 수 없습니다.");
        }
        // 브라우저의 다운로드 API 사용
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = showFileName;
        link.click();
        URL.revokeObjectURL(url);
    }
    catch (err) {
        console.error("다운로드 실패:", err);
        throw err;
    }
};
